module.exports = "<div id=\"slot\">\n    <img id=\"slot-image\" src=\"\" alt=\"\" width=\"100%\" />\n</div>\n<!--assets\\cards\\1_of_clubs.svg-->\n";